module.exports = __webpack_public_path__ + "static/img/how-to-become-a-business-intelligence-analyst.e0d3af50.jpg";